import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { EMPTY } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthNewService } from 'src/auth/services/auth-new.service';
@Component({
  selector: 'app-request-reset',
  templateUrl: './request-reset.component.html',
  styleUrls: ['./request-reset.component.scss']
})
export class RequestResetComponent implements OnInit {

  form = this.fb.group({
    email: ['', Validators.required]
  });

  constructor(private fb: UntypedFormBuilder, private auth: AuthNewService, private router: Router, private route: ActivatedRoute) { }

  ngOnInit(): void {
  }

  onSubmit() {

    if (this.form.invalid){
      return;
    }

    this.auth.forgotPassword(this.form.value.email).pipe(catchError(error => {
      console.log(error);
      return EMPTY;
    })).subscribe(response => {

      this.router.navigate(['complete'], {relativeTo: this.route, state: {userEmail: this.form.value.email}});

    });

  }

}
